
import {CONFIG} from "../config";
import {Injectable} from "@angular/core";
import * as moment from "moment";

export const LEVELS = {
    DEBUG: 4,
    INFO: 3,
    WARNING: 2,
    ERROR: 1,
    DISABLE_ERRORS: 0
};

@Injectable()
export class Logger{

    private level: number = 4;
    private regExp = /(\w+)@|at\s+.+\s+\(([\w\._:\s\/-]+)\)/gi;

    constructor()
    {
        this.level = CONFIG.LOG_LEVEL;
    }

    public debug(...data)
    {
        if(this.level >= LEVELS.DEBUG){
            let sCallerName = this.getCalerName();
            var args = Array.prototype.slice.call(arguments);
            args.unshift(sCallerName);
            args.unshift("log");
            this.log.apply(this, args);
        }
    }
    public error(...data)
    {
        if(this.level >= LEVELS.ERROR){
            let sCallerName = this.getCalerName();
            var args = Array.prototype.slice.call(arguments);
            args.unshift(sCallerName);
            args.unshift("error");
            args.push(new Error().stack);
            this.log.apply(this, args);
        }
    }
    public info(...data)
    {
        if(this.level >= LEVELS.INFO){
            let sCallerName = this.getCalerName();
            var args = Array.prototype.slice.call(arguments);
            args.unshift(sCallerName);
            args.unshift("info");
            this.log.apply(this, args);
        }
    }
    public warn(...data)
    {
        if(this.level >= LEVELS.ERROR){
            let sCallerName = this.getCalerName();
            var args = Array.prototype.slice.call(arguments);
            args.unshift("warn");
            args.unshift(sCallerName);
            this.log.apply(this, args);
        }
    }

    private getCalerName()
    {
        let sCallerName;
        let re = this.regExp;
        let aRegexResult;
        for(let i = 0; i < 3; i++){
            aRegexResult = re.exec(new Error().stack);
        }
        sCallerName = aRegexResult ? aRegexResult[2]: "";
        return sCallerName;

    }

    private log(type){
        let data = [].slice.call(arguments,1);
        data.unshift("[" + type.toUpperCase() + "]");
        data.unshift("["+moment().format("YYYY-MM-DD HH:mm:ss")+"] -");
        console[type].apply(this, data);
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/logger.ts